export default __webpack_public_path__ + "static/media/waterfalls6.ba40e92d.webp";